/*
 * Copyright (C) 2018 Bruno López Trigo
 * 
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

export const BASENAME = "/ExpliClas";
//export const API_ROOT = "http://172.16.240.114:8080/expliclas-api/api";
export const API_ROOT = "https://demos.citius.usc.es/expliclas-api/api";
//export const API_DOC = "http://172.16.240.114:8080/expliclas-api/";
export const API_DOC = "https://demos.citius.usc.es/expliclas-api/";
